import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import { withTranslation, useTranslation } from 'react-i18next'

import Button from 'srcReact/components/common2/Button'
import CodeVerificationBox from 'srcReact/components/common2/CodeVerificationBox'

import styles from './styles.module.scss'
import { redirectToPage } from 'srcReact/helpers/history'
import queryString from 'query-string'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

const ConfirmEmail = ({
  checkEmailSentOnce,
  resendActivationCodeLoading,
  sendActivationCode,
  validateActivationCodeLoading,
  resendActivationCodeSent,
  validateActivationCodeValidated,
  validateActivationCode,
  updateStep,
  previousStep,
  setPreviousStep,
  goToPreviousStep,
  formState,
  setFormState,
  isResend,
  isNative
}) => {
  const [value, setValue] = useState(formState.codeConfirmationEmail)
  const [emailSentOnce, setEmailSentOnce] = useState(false)
  const [verifiedCodeFromHere, setVerifiedCodeFromHere] = useState(false)
  const email = formState.email

  const { t } = useTranslation()
  const [showSentCodeSuccess, setShowSentCodeSuccess] = useState('')

  useEffect(() => {
    if (!resendActivationCodeLoading && resendActivationCodeSent && isResend) {
      setShowSentCodeSuccess(true)
    } else {
      setShowSentCodeSuccess(false)
    }
  }, [resendActivationCodeLoading, resendActivationCodeSent])

  useEffect(() => {
    if (!checkEmailSentOnce && !emailSentOnce) {
      sendActivationCode(email)
      setEmailSentOnce(true)
    }
  }, [checkEmailSentOnce])

  useEffect(() => {
    if (validateActivationCodeValidated !== 'not_sent' && validateActivationCodeValidated && verifiedCodeFromHere) {
      setPreviousStep([...previousStep, 'confirmEmail'])
      if (formState.workplace_invitations && formState.workplace_invitations.length > 0) {
        updateStep('invitation')
      } else {
        updateStep('password')
      }
      setFormState({
        ...formState,
        codeConfirmationEmail: value
      })
    }
  }, [validateActivationCodeValidated, verifiedCodeFromHere])
  const codeValueToArray = (val) => val.trim().split('')

  const changeEmail = () => {
    let queryStringObj = queryString.parse(location.search)
    if (queryStringObj && queryStringObj.step) {
      redirectToPage('/auth?from=signup', isNative)
    } else {
      goToPreviousStep()
    }
  }
  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        <div className={styles.resend} onClick={() => !resendActivationCodeLoading && sendActivationCode(email, true)}>
          {t('signup.confirm_email.resend')}
        </div>
        <div className={styles.yourEmail}>
          {t('signup.confirm_email.email')} <span className={styles.email}>{email}</span>{' '}
          <span className={styles.change} onClick={changeEmail}>
            {`(${t('global.change')})`}
          </span>
        </div>
        <CodeVerificationBox
          autoFocus={false}
          customClassName={styles.codeInput}
          fields={5}
          onChange={(e) => setValue(e)}
          type='text'
          values={codeValueToArray(value)}
          disabled={
            value &&
            value.length >= 5 &&
            validateActivationCodeValidated !== 'not_sent' &&
            validateActivationCodeValidated
          }
        />
      </div>
      {value &&
        value.length >= 5 &&
        validateActivationCodeValidated !== 'not_sent' &&
        !validateActivationCodeValidated && (
          <ErrorMessage text={t('account_settings.update_form.errorCode')} className={styles.errorCode} />
        )}
      <div className={styles.buttonContainer}>
        <Button
          text={t('global.confirm')}
          size='large'
          disabled={value.length !== 5 || validateActivationCodeLoading}
          handleClick={() => {
            validateActivationCode(email, value.toUpperCase())
            setVerifiedCodeFromHere(true)
          }}
        />
      </div>
      {showSentCodeSuccess && (
        <p
          className={styles.codeSentSuccess}
          dangerouslySetInnerHTML={{
            __html: t('signup.confirm_email.codeResentSuccess')
          }}
        />
      )}
    </div>
  )
}

function mapStateToProps(state) {
  const {
    common: { isNative },
    authentication: {
      checkEmailSentOnce,
      resendActivationCodeLoading,
      resendActivationCodeSent,
      validateActivationCodeLoading,
      validateActivationCodeValidated,
      isResend
    }
  } = state
  return {
    checkEmailSentOnce,
    resendActivationCodeLoading,
    resendActivationCodeSent,
    validateActivationCodeLoading,
    validateActivationCodeValidated,
    isResend,
    isNative
  }
}

const actionCreators = {
  sendActivationCode: authenticationActions.sendActivationCode,
  validateActivationCode: authenticationActions.validateActivationCode
}

const ExtendedComponent = withTranslation('common')(ConfirmEmail)

const connectedConfirmEmail = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedConfirmEmail as ConfirmEmail }
